import CardSection from "../../../../conponents/CardSection/CardSection";
import PersianDateField from "../../../../conponents/PersianDateField/PersianDateField";
import SelectField from "../../../../conponents/selectField/SelectField.jsx";
import styles from "./ExpenseVehicleSection.module.css";
import { normalizeNumber } from "../../../../services/numberFormatter";



const ExpenseVehicleSection = ({

    cars,

    values,

    errors,

    touched,

    setFieldValue,

    setFieldTouched,

}) => {

    const carOptions = cars.map((car) => ({

        value: car.id,

        label: car.title,

    }));

    return (

        <CardSection title="اطلاعات هزینه">

            <div className={styles.container}>

                <SelectField

                    id="carId"

                    name="carId"

                    label="خودرو"

                    required

                    value={values.carId}

                    options={carOptions}

                    error={errors.carId}

                    touched={touched.carId}

                    onChange={(value) =>{

                        const selectedCar = cars.find(

                            x => x.id === value
                
                        );

                        setFieldValue(

                            "carId",

                            value

                        );

                        setFieldValue(

                            "operDonKM",

                            normalizeNumber(
                                selectedCar?.kilometer ?? ""
                            )

                        );

                    }}

                    onBlur={() =>

                        setFieldTouched(

                            "carId",

                            true

                        )

                    }

                />

                <PersianDateField

                    id="operDonDate"

                    name="operDonDate"

                    label="تاریخ هزینه"

                    required

                    value={values.operDonDate}

                    error={errors.operDonDate}

                    touched={touched.operDonDate}

                    onChange={(value) =>

                        setFieldValue(

                            "operDonDate",

                            value

                        )

                    }

                    onBlur={() =>

                        setFieldTouched(

                            "operDonDate",

                            true

                        )

                    }

                />

            </div>

        </CardSection>

    );

};

export default ExpenseVehicleSection;